// @flow
import ApiClient from 'utils/ApiClient';
import * as ActionType from 'action_types/CurrentUserActionTypes';
import Dispatcher from 'dispatcher';
import CurrentUser from 'models/CurrentUser';
import ApiServiceH360 from 'modules/h360/api/ApiService';

const H360_AGENCY = {
  id: 'h360',
  slug: 'h360'
};
class CurrentUserActions {
  startCurrentUserPolling(): Promise<any> {
    return ApiClient.startCurrentUserLongPolling(
      '/api/internal/users/current.json',
      response => {
        const currentUser = new CurrentUser(response);
        if (currentUser.id === null) {
          ApiClient.cancelCurrentUserLongPolling();
        }
        if (currentUser.isAdvisor) {
          this.getAdvisorAgency(currentUser);
        } else {
          this.dispatchCurrentUser(currentUser);
        }
      },
      0
    );
  }

  getAdvisorAgency = (current: any) => {
    ApiServiceH360.getUser(current.id).then(response => {
      const agency =
        response.data.user.advisor.agencyBusinessPartner || H360_AGENCY;
      const idAdvisor = response.data.user.advisor.id;
      this.dispatchCurrentUser(current, agency, idAdvisor);
    });
  };

  dispatchCurrentUser = (current: any, agency?: any, idAdvisor?: string) => {
    Dispatcher.dispatch({
      type: ActionType.CURRENT_USER_POLLING_LOADED,
      currentUser: current,
      agency,
      idAdvisor
    });
  };

  getCurrent(success?: Function): Promise<any> {
    return ApiClient.get({
      path: '/users/current.json',
      success: response => {
        Dispatcher.dispatch({
          type: ActionType.CURRENT_USER_LOADED,
          currentUser: new CurrentUser(response)
        });
        if (success) {
          success();
        }
      },
      error: error => {
        Dispatcher.dispatch({
          type: ActionType.CURRENT_USER_LOAD_ERROR,
          error
        });
      }
    });
  }

  getRentalMonthsByRent(
    user_id: string,
    rent_id: string,
    data: {} = {},
    success?: () => void
  ): Promise<any> {
    return ApiClient.get({
      path: `/users/${user_id}/rents/${rent_id}/rental_months.json`,
      data,
      success: response => {
        Dispatcher.dispatch({
          type: ActionType.USER_RENTAL_MONTHS_BY_RENT,
          data: response,
          metadata: response
        });
        if (success !== undefined) {
          success(response);
        }
      }
    });
  }

  getCardsByUser(user_id: string): Promise<any> {
    return ApiClient.get({
      path: `/users/${user_id}/cards`,
      success: response => {
        Dispatcher.dispatch({
          type: ActionType.USER_CARDS,
          cards: response.cards
        });
      }
    });
  }

  updateUserData(user_id: string, params: {} = {}): Promise<any> {
    return ApiClient.get({
      path: `/users/${user_id}.json`,
      jsonData: params,
      success: response => {},
      error: error => {
        Dispatcher.dispatch({
          type: ActionType.CURRENT_USER_LOAD_ERROR,
          error
        });
      }
    });
  }

  signUpVerifications(
    userId: string,
    data = {},
    success?: () => void,
    error?: () => {}
  ): Promise<any> {
    return ApiClient.post({
      path: `/users/${userId}/sign_up_verifications.json`,
      jsonData: data,
      success: success,
      error: error
    });
  }

  terms_and_conditions(
    user_id: string,
    success?: () => void,
    error?: () => void
  ): Promise<any> {
    return ApiClient.post({
      path: `/users/${user_id}/publishing_agreements.json`,
      jsonData: { agreement_type: 'home_publishing' },
      success,
      error
    });
  }

  createUserTermsAndConditions(userId: string) {
    return ApiClient.post({
      path: `/users/${userId}/publishing_agreements.json`,
      jsonData: { agreement_type: 'terms_and_conditions' }
    });
  }

  acceptUserTermsAndConditions(userId: string, agreementId: string) {
    return ApiClient.put({
      path: `/users/${userId}/publishing_agreements/${agreementId}.json`,
      jsonData: { agreement_type: 'terms_and_conditions' }
    });
  }

  update_terms_and_conditions(
    user_id: string,
    publishing_agreements_id: string,
    success?: () => void,
    error?: () => void
  ): Promise<any> {
    return ApiClient.put({
      path: `/users/${user_id}/publishing_agreements/${publishing_agreements_id}.json`,
      jsonData: { agreement_type: 'home_publishing' },
      success,
      error
    });
  }

  update_password_user(
    params: {},
    success?: () => void,
    error?: () => void
  ): Promise<any> {
    return ApiClient.put({
      path: '/users/update_using_current.json',
      jsonData: params,
      success,
      error
    });
  }

  createBillData(params: {}, userId: string, error?: () => void): Promise<any> {
    return ApiClient.post({
      path: `/users/${userId}/legal_entities`,
      jsonData: params,
      success: response => {
        Dispatcher.dispatch({
          type: ActionType.LEGAL_ENTITY_CREATE,
          data: response
        });
      },
      error
    });
  }

  updateBillData(
    params: {},
    userId: string,
    billId: string,
    error?: () => void
  ): Promise<any> {
    return ApiClient.put({
      path: `/users/${userId}/legal_entities/${billId}`,
      jsonData: params,
      success: response => {
        Dispatcher.dispatch({
          type: ActionType.LEGAL_ENTITY_EDIT,
          data: response
        });
      },
      error
    });
  }

  sendBillData(
    params: {},
    success?: () => void,
    error?: () => void
  ): Promise<any> {
    return ApiClient.post({
      path: '/invoices.json',
      jsonData: params,
      success,
      error
    });
  }
}

export default new CurrentUserActions();
